import { getStore, setStore, removeStore } from './localStorage';

export function getDict() {
  return getStore("SYS_DICT_LIST");
}
export function setDict(data) {
  setStore("SYS_DICT_LIST",data);
}